import { Controller } from '@hotwired/stimulus'

const DURATION_MS = 1400

const easeOutCubic = progress => 1 - (1 - progress) ** 3

// Pops the floating cards in and counts the phone's metrics up from zero
// once a quarter of the preview is in view. Without JS, or with reduced
// motion, the cards stay visible and the metrics keep their final values.
export default class extends Controller {
  static targets = ['count']

  connect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    this.element.dataset.visible = 'false'
    this.observer = new IntersectionObserver(
      this.#handleIntersect.bind(this), { threshold: 0.25 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    cancelAnimationFrame(this.frame)
  }

  #handleIntersect(entries) {
    if (!entries.some(entry => entry.isIntersecting)) return

    this.observer.disconnect()
    this.element.dataset.visible = 'true'
    this.#countUp()
  }

  #countUp() {
    const start = performance.now()

    const tick = now => {
      const progress = Math.min(1, (now - start) / DURATION_MS)
      this.#render(easeOutCubic(progress))
      if (progress < 1) this.frame = requestAnimationFrame(tick)
    }

    this.frame = requestAnimationFrame(tick)
  }

  #render(fraction) {
    this.countTargets.forEach(target => {
      const { to, decimals } = target.dataset
      target.textContent = (Number(to) * fraction).toFixed(Number(decimals))
    })
  }
}
